import { createContext, useContext } from "react";
import {
  FormProvider as RHFFormProvider,
  FieldValues,
  useFormContext as useRHFFormContext,
} from "react-hook-form";
import { FormProviderProps } from "./types";

const FormProviderContext = createContext<
  | {
      disabled?: boolean;
      readOnly?: boolean;
    }
  | undefined
>(undefined);

export const FormProvider = <T extends FieldValues>(
  props: FormProviderProps<T>,
) => {
  const { methods, disabled, readOnly, children } = props;

  return (
    <FormProviderContext.Provider value={{ disabled, readOnly }}>
      <RHFFormProvider {...methods}>{children}</RHFFormProvider>
    </FormProviderContext.Provider>
  );
};

/**
 * This hook is used to get the merged form context: react-hook-form context and the FormProvider custom context
 * @returns The form context and the react-hook-form context
 */
export const useFormContext = () => {
  const context = useContext(FormProviderContext);
  const rhfContext = useRHFFormContext();

  if (!context || !rhfContext) {
    throw new Error("formContext must be used within a FormProvider");
  }

  return { ...context, ...rhfContext };
};
